import React from 'react';

const RedFace = ({ color = 'red', size = 142, active, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 142 142"
      {...props}
    >
      <g
        id="Group_42237"
        data-name="Group 42237"
        transform="translate(-3396 21475)"
      >
        <g
          id="Ellipse_217"
          data-name="Ellipse 217"
          transform="translate(3396 -21475)"
          stroke="red"
          fill={active ? color : 'none'}
          strokeWidth="15"
        >
          <circle cx="71" cy="71" r="71" stroke="none" />
          <circle cx="71" cy="71" r="63.5" fill="none" />
        </g>
        <path
          id="Path_25997"
          data-name="Path 25997"
          d="M3431.823-21373.484c2.285-4.762,39.173-39.816,71.69.559"
          transform="translate(-1 1)"
          fill="none"
          stroke={active ? 'white' : color}
          // stroke="red"
          strokeWidth="9"
        />
      </g>
    </svg>
  );
};

export default RedFace;
